var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-picker-wrap",attrs:{"id":_vm.id}},[_c('div',{staticClass:"color-placeholder",on:{"click":_vm.triggerUI}},[_c('p',[_vm._v("Select a custom color")]),_vm._v(" "),_c('button',{style:({ backgroundColor: _vm.mutatedColor })})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showUI)?_c('Chrome',{attrs:{"value":_vm.mutatedColor},on:{"input":_vm.updateColor}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e118c3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/fields/color-picker.vue
// module id = 70
// module chunks = 0